import { makeAutoObservable } from "mobx";

function getCampaignAuth(data) {
  const ca = data?.campaign_authentications
  return Array.isArray(ca) ? ca[0] : ca
}

export default class CampaignAuthentication {

  constructor(campaignAuthentication = {}) {
    const campaignAuth = getCampaignAuth(campaignAuthentication)

    this.authentication_id = campaignAuthentication.id
    this.avatar = campaignAuthentication.avatar
    this.provider = campaignAuthentication.provider
    this.reach = campaignAuthentication.reach
    this.username = campaignAuthentication.username
    this.country = campaignAuthentication.country
    this.tags = campaignAuthentication.tags || []
    this.status_id = campaignAuth?.status_id
    this.campaign_authentication_id = campaignAuth?.id
    this.comments = campaignAuth?.comments || []
    this.client_comments = campaignAuth?.client_comments || []
    this.selection_status = campaignAuth?.selection_status ?? 'pending'
    this.reachbird_approved = !!campaignAuthentication.reachbird_approved
    this.main_country = campaignAuthentication.main_country || ''
    this.rating_professional = campaignAuthentication.rating_professional ?? null
    this.rating_quality = campaignAuthentication.rating_quality ?? null
    this.rating_count = campaignAuthentication.rating_count || 0
    this.isSelected = false
    makeAutoObservable(this)
  }
}
